export const site = "http://localhost:8081"
export const versionNum = '21'
export const url = "http://localhost:8081"
